import { Accordion, Button, useAccordionButton } from '@valid-eval/shared-react-components';
import parse from 'html-react-parser';
import { useId, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

type ContentPreviewProps = {
  content: string;
  children?(content: React.ReactNode): React.ReactNode;
};

const AccordionButton = ({
  eventKey,
  activeEventKey,
}: {
  eventKey: string;
  activeEventKey: string | null;
}) => {
  const { t } = useTranslation();
  const decorateOnClick = useAccordionButton(eventKey);

  return (
    <Button variant="link" className="mt-2 pe-2 ps-2" onClick={decorateOnClick}>
      <i className="fa-solid fa-eye" />
      {t(activeEventKey === eventKey ? 'common.hide_preview' : 'common.show_preview')}
    </Button>
  );
};

export const ContentPreview = ({ content, children }: ContentPreviewProps) => {
  const eventKey = useId();
  const { t } = useTranslation();
  const [activeEventKey, setActiveEventKey] = useState<string | null>(null);
  const parsedContent = useMemo(() => {
    return content ? parse(content) : <span className="text-muted">{t('common.no_content')}</span>;
  }, [content]);

  return (
    <Accordion activeKey={activeEventKey} onSelect={(key) => setActiveEventKey(key as string)}>
      <AccordionButton eventKey={eventKey} activeEventKey={activeEventKey} />
      <Accordion.Collapse eventKey={eventKey}>
        <div className="p-4 mt-2 border rounded shadow-sm bg-light">
          {children ? children(parsedContent) : parsedContent}
        </div>
      </Accordion.Collapse>
    </Accordion>
  );
};
